import { ChangeDetectorRef, Directive, Input } from '@angular/core';
import { Address } from '@df/session/api/address-book/address';

/**
 * @Depreciated dont use it
 */
@Directive()
export class AddressComponentDef {
    /**
     * Address model
     */
    protected _model!: Address;

    /**
     * Model setter
     */
    @Input({
        required: true
    })
    set model(model: Address) {
        this._model = model;
        this._ref.detectChanges();
    }

    /**
     * Model getter
     */
    get model(): Address {
        return this._model;
    }

    @Input() custom: any;

    constructor(protected _ref: ChangeDetectorRef) {}
}
